export enum SortTypeDisplayValue {
    LOWESTPRICE = "Low - High",
    MAXIMUMPRICE = "High - Low",
    NEWPRODUCTS = "New",
    PRIORITYSORT = "Recommended"                
}